.e7{color:var(--gray-700);}